__turbopack_context__.v({
  "actions": "Ngp0iq_actions",
  "body": "Ngp0iq_body",
  "brandWash": "Ngp0iq_brandWash",
  "content": "Ngp0iq_content",
  "dotGridFloor": "Ngp0iq_dotGridFloor",
  "heading": "Ngp0iq_heading",
  "lead": "Ngp0iq_lead",
  "mark": "Ngp0iq_mark",
  "markIcon": "Ngp0iq_markIcon",
  "reference": "Ngp0iq_reference",
  "section": "Ngp0iq_section",
});
